import React, { createRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoginAction } from './use-Login';
import styles from './style.module.css';
import { LocalData } from "../../service/localStorage";
import { changeDirection, faviconUpdate } from '../../utils';
import { Set_AccessToken } from "../../Redux/actions/actionNames";
import { Helmet } from "react-helmet";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from 'react-i18next';
import CircularProgress from "@material-ui/core/CircularProgress";
import { snack } from '../../utils/SnackbarUtilsConfigurator';
import { LoginApi } from '../../service/API';
import ProgressBar from '../../design-system/lib/ProgressBar';
import { RefreshTokenCheck } from '../../helper/api';
import { get_refreshToken } from '../../helper/UserData/userdate';
import {  Redirect } from "react-router-dom";
import { useQuery } from '../../hooks/useQuery';
import ProgressIndicator from '../../design-system/lib/ProgressIndicator';
import { DispatcherApi } from '../../service/API/dispatcher';
import history from '../../service/history';

export const MagicLink = () => {

    const searchParams = useQuery();
    const token = searchParams.get("token");

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const localData = new LocalData();
    const [istokenCheck, setIstokenCheck] = useState(true);
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const authenticated = useSelector((state) => state.LocalData.access_token);
    const [gettingStarted, setGettingStarted] = useState(false);



    useEffect(() => {
        localStorage.clear()
        faviconUpdate();
        changeDirection();
       setTimeout(() => {
         LoginClick()
       }, 200);
    }, [])



    const LoginClick = React.useCallback(async() => {
        try {
            const result = await LoginAction({ token});
            if (result) {
                const loginApi = new LoginApi();                    
                const Dashboardlogin = await loginApi.Dashboardlogin(result.adminToken);
                const Dispatcher = new DispatcherApi();
                const data = await Dispatcher.Setting({ userId: result.userId, refreshToken: result.refreshToken });

                if (data) {
                    if (!data.onboardingStatus.getStartCompleted) {
                        setGettingStarted(true)
                       setTimeout(() => {
                         dispatch(Set_AccessToken(result.accessToken));
                         history.push("/gettingstarted")

                       }, 150);
                    }else{
                        setTimeout(() => {
                            dispatch(Set_AccessToken(result.accessToken));
                           // history.push("/")
                            var priority = ["Ondemand", "Pickup", "Delivery", "PickupDelivery"];
                            let SortedOrderTypes = data.orderTypes.sort((a, b) => priority.indexOf(a) - priority.indexOf(b))

                             history.push(`/`);
                            // window.location.reload();
                          }, 150);

                    }

                }

            }else {
                history.push("/login")
                window.location.reload()
            }

        } catch (error) {
            if (error.code === -400) {
                snack.warning_i18(error.message)

            } else if (error.code === -1) {
                snack.warning_i18("enterDataCorrectly")
            } else {

            }
        }
      }, [token]);



    
      if (isLogin()  && authenticated && gettingStarted) {
        return <Redirect
            to={"/gettingstarted"}
        />
    }
    

    if (isLogin() &&  authenticated  && !gettingStarted) {
        return <Redirect
            to={"/"}
        />
    }
    return <>

        <Helmet>
            <title> {global.config.dispatcherText.title}</title>
        </Helmet>
        <Paper
            style={{
                width: "348px",
                height: "313px",
                position: "absolute",
                top: "26%",
                float: "right",
                right: "calc(50vw - 174px)",
                borderRadius: "8px",
                display:"flex",
                flexDirection:"row",
                justifyContent:"center",
                alignItems:"center"
            }}
            elevation={3}
        >
          <ProgressIndicator theme='On_Light' style={{width:"50px",height:"50px"}} />
          </Paper>
    </>

};


function isLogin () {
    if (String(window.location.href).includes("login")) {
      return true
    } else {
      return false
    }
  }
  


